import { Component } from 'react';

import { twclsx } from 'utils/twclsx';

import Icon from './Icon';

interface SearchGroupComponentProps {
    title: string;
    className?: string;
    children?: string | JSX.Element | JSX.Element[];
    open?: boolean;
}

interface SearchGroupComponentState {
    active: boolean;
}

class SearchGroup extends Component<SearchGroupComponentProps, SearchGroupComponentState> {
    constructor(props: SearchGroupComponentProps) {
        super(props);
        this.state = {
            active: false,
        };
    }

    toggleMenu = () => {
        this.setState({ active: !this.state.active });
    };

    render() {
        const { className, children, title } = this.props;

        return (
            <div className={twclsx('flex', 'py-2', 'flex-col', className)}>
                <div
                    className={twclsx(
                        'flex',
                        'w-full',
                        'px-2',
                        'sticky',
                        'top-0',
                        'z-10',
                        'bg-white',
                        'justify-between',

                        this.state.active && 'pb-2'
                    )}
                >
                    <div className="font-bold no-select  text-center  ">{title}</div>
                    <div className="flex items-center justify-center">
                        <div className="flex "> {Array.isArray(children) && <>{children?.[1]}</>} </div>
                        <div className="flex gap-2  flex-none items-start">
                            {!this.props.open && (
                                <div onClick={this.toggleMenu} className="cursor-pointer">
                                    {this.state.active ? (
                                        <Icon>
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path d="M6 15l6 -6l6 6" />
                                        </Icon>
                                    ) : (
                                        <Icon>
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path d="M6 9l6 6l6 -6" />
                                        </Icon>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {this.state.active ||
                    (this.props.open && (
                        <div className="px-2">{Array.isArray(children) ? children?.[0] : children}</div>
                    ))}
            </div>
        );
    }
}

export default SearchGroup;
